module.exports = __webpack_public_path__ + "img/star-of-david.90ff0be9.svg";